module.exports = __webpack_public_path__ + "img/a3.5eafe2c8.jpg";